/*
 * @Author: Michael 
 * @Date: 2018-09-17 17:15:40 
 * @Last Modified by: Michael
 * @Last Modified time: 2019-05-28 17:54:47
 */

import _Vue, { VueConstructor } from 'vue';
import ToastComponent from './Toast.vue';

let $vm: any;
interface Toast {
  hide: Function;
}

export default {
  install(Vue: typeof _Vue) {
    if (!$vm) {
      const ToastPlugin: VueConstructor = Vue.extend(ToastComponent);
      $vm = new ToastPlugin({
        el: document.createElement('div')
      });
      document.body.appendChild($vm.$el);
    }

    $vm.show = false;
    const toast: Toast = {
      hide(): void {
        $vm.show = false;
      }
    };

    type toastType = 'success' | 'info' | 'warning' | 'error';
    const typeArray: ReadonlyArray<toastType> = ['success', 'info', 'warning', 'error'];

    typeArray.forEach((type: toastType) => {
      (toast as any)[type] = (text: string, duration: number = 2000): void => {
        let timer: number;
        if (!$vm.show) {
          $vm.show = true;
          $vm.text = text;
          $vm.type = type;
          timer = window.setTimeout(() => {
            toast.hide();
            clearTimeout(timer);
          }, duration);
        }
      };
    });

    if (!Vue.$toast) {
      Vue.$toast = toast;
    }

    Vue.mixin({
      created() {
        this.$toast = Vue.$toast;
      }
    });
  }
};